<template>
  <header>
    <div class="author-top-wrap">
      <div class="author-top-content">
        <div class="author-top-left">
          <router-link class="logo" :to="isAuthor ? '/excl-author/mine' : ''">
            <div class="img"></div>
            <span class="txt">有看投大咖操作平台</span>
            <div class="icon-bg">
              <span>Beta</span>
            </div>
          </router-link>
          <div v-if="isLogin && isAuthor" class="wrap-2">
            <div class="tab">
              <div
                class="link"
                v-for="(item, index) in tabContent"
                :key="index"
                :class="{ choose: activeTabsIndex === index }"
                @click="linkChange(item)"
              >
                <div class="font">{{ item.name }}</div>
                <!-- <div class="border"></div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- 头像弹窗 -->
        <div v-if="isAuthor">
          <el-popover
            placement="bottom-end"
            :visible-arrow="false"
            width="300"
            trigger="hover"
            popper-class="user-info-popover"
          >
            <div class="login" slot="reference">
              <span class="name">{{ nickname }}</span>
              <div class="img-circle">
                <div
                  class="img-bg"
                  :style="{ 'background-image': `url(${avatar})` }"
                ></div>
              </div>
            </div>
            <template>
              <div class="pop-swap">
                <div class="logged-header">
                  <base-avatar :src="avatar" :size="48"></base-avatar>
                  <span class="user-nick">{{ nickname }}</span>
                </div>
                <div class="logged-login">
                  <router-link class="logged-edit" to="/excl-author/mine"
                    >个人中心</router-link
                  >
                  <a class="logged-exit" @click="logout">退出登录</a>
                </div>
              </div>
            </template>
          </el-popover>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import htest from './images/h-test.png'
import BaseAvatar from '@/components/BaseAvatar/BaseAvatar'
export default {
  name: 'AuthorTopTab',
  components: { BaseAvatar },
  data() {
    return {
      tabContent: [
        {
          name: '点金',
          path: '/excl-author/dianjin'
        },
        {
          name: '锦囊',
          path: '/excl-author/jinnang'
        },
        {
          name: '课程',
          path: '/excl-author/course'
        },
        {
          name: '我的',
          path: '/excl-author/mine',
          static: true
        }
      ],
      headIcon: htest
    }
  },
  computed: {
    activeTabsIndex() {
      const path = this.$route.path
      return this.tabContent.findIndex(item =>
        item.path === '/' ? item.path === path : ~path.indexOf(item.path)
      )
    },
    isLogin() {
      return this.$store.getters['auth/isLogin']
    },
    authorInfo() {
      console.log('authorInfo:', this.$store.state.user.authorInfo)
      return this.$store.state.user.authorInfo
    },
    userInfo() {
      console.log('userinfo:', this.$store.state.user.userInfo)
      console.log('loginInfo:', this.$store.state.auth.loginInfo)
      return this.$store.state.user.userInfo
    },
    nickname() {
      if (this.authorInfo && this.authorInfo.nickname) {
        return this.authorInfo.nickname
      } else {
        return this.userInfo ? this.userInfo.mobileMask : ''
      }
    },

    isAuthor() {
      return this.$store.getters['user/isAuthor']
    },
    // 大咖资料修改中
    isEditing() {
      return this.$store.getters['user/isEditing']
    },
    avatar() {
      var res = !this.authorInfo ? '' : this.authorInfo.headpic1
      if (!res) {
        res = this.userInfo ? this.userInfo.avatar : ''
      }
      return res
    }
  },
  created() {},
  methods: {
    linkChange(item) {
      console.log('linkChange:', item)
      if (this.isEditing && !item.static) {
        this.$alert(`当前个人资料正在审核，【${item.name}】暂不可用`, '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
      } else {
        this.$router.push(item.path)
      }
    },
    logout() {
      this.$store.dispatch('auth/logout')
    }
  }
}
</script>

<style lang="scss" scoped>
.pop-swap {
  width: 100%;
  height: 170px;
  .pop-header {
    width: 100%;
    height: 114px;
  }
  .logged-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 114px;
    background: url('./images/bg.png') no-repeat center;
    border-radius: 5px 5px 0;
    background-size: cover;
    .user-nick {
      padding-top: 12px;
      font-size: 16px;
      color: #262626;
    }
  }
  .logged-mine-container {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 80px;

    .logged-mine,
    .logged-follow,
    .logged-currency {
      padding-top: 28px;
      background: no-repeat top;
      background-size: 18px auto;
      font-size: 14px;
      color: #858585;
      text-decoration: none;
    }

    .logged-mine {
      background-image: url('~@/assets/images/icons/icon-mine.png');
    }

    .logged-follow {
      background-image: url('~@/assets/images/icons/icon-follow.png');
    }

    .logged-currency {
      background-image: url('~@/assets/images/icons/icon-currency.png');
    }
  }
  .logged-login {
    display: flex;
    align-items: center;
    height: 56px;
    border-top: 1px solid #ebebeb;
    text-align: center;

    .logged-edit {
      position: relative;
      text-decoration: none;
      &:hover {
        color: #046bcc;
      }
      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 1px;
        height: 14px;
        background-color: #ebebeb;
      }
    }

    .logged-edit,
    .logged-exit {
      flex: auto;
      font-size: 14px;
      color: #262626;
      cursor: pointer;
      &:hover {
        color: #046bcc;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
header {
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1001;
  top: 0px;
}

.author-top-wrap {
  //   width: 1920px;
  height: 70px;
  background-color: #02284d;
  box-shadow: 0px 5px 10px 0px rgba(2, 40, 77, 0.4);
  display: flex;
  flex-direction: column;
}
.author-top-content {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .author-top-left {
    display: flex;
  }
}
.logo {
  height: 40px;
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  .img {
    width: 40px;
    height: 40px;
    background: url('./images/logo.png') no-repeat;
  }
  .txt {
    width: 193px;
    font-family: MicrosoftYaHei;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 40px;
    letter-spacing: 1px;
    color: #ffffff;
    align-items: center;
    padding-left: 15px;
  }
  .icon-bg {
    display: flex;
    > span {
      display: inline-flex;
      justify-content: center;
      width: 40px;
      height: 16px;
      background-color: #ffffff;
      border-radius: 3px;

      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      // line-height: 40px;
      letter-spacing: 0px;
      color: #02284d;
    }
  }
}
.wrap-2 {
  height: 100%;
}
.tab {
  width: 282px;
  height: 100%;
  margin-left: 110px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .link {
    flex-direction: column;
    text-decoration: none;
    cursor: pointer;
  }
  .font {
    width: 34px;
    font-family: MicrosoftYaHei;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 16px;
    letter-spacing: 1px;
    color: #ffffff;
    margin-top: 14px;
    &::after {
      content: ' ';
      width: 34px;
      height: 4px;
      display: block;
      background: none;
      margin-top: 10px;
    }
    &:hover {
      &::after {
        background-color: #ffffff;
      }
    }
  }
  .choose {
    .border {
      width: 32px;
      height: 4px;
      background-color: #ffffff;
      margin-top: 11px;
    }
    .font {
      &::after {
        background-color: #ffffff;
      }
    }
  }
}
.login {
  cursor: pointer;
  width: 150px;
  height: 46px;
  display: inline-flex;
  align-items: center;
  .name {
    width: 100px;
    height: 15px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 40px;
    letter-spacing: 1px;
    color: #ffffff;
    opacity: 0.5;
    justify-content: flex-end;
    display: inline-flex;
    align-items: center;
    margin-right: 10px;
  }
  .img-circle {
    border-radius: 100%;
    border: solid 3px;
    border-color: rgba(255, 255, 255, 0.2);
    .img-bg {
      width: 40px;
      height: 40px;
      border-radius: 100%;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      border-radius: 50%;
    }
  }
  .img {
    width: 40px;
    height: 40px;
    border-radius: 100%;
  }
}
</style>

<style lang="scss">
body .user-info-popover {
  margin-top: 5px !important;
  padding: 0;
  border-radius: 5px;
  border: none;
}
</style>

<style>
body .el-message-box .el-button {
  width: 100px !important;
}
.avatar {
  background-repeat: no-repeat !important;
  background-size: 100% 100% !important;
}
</style>
